import { Tooltip } from '@mui/material';
import { ReactComponent as VIcon } from '@elementary/common-ui/assets/v-green.svg';
import { StatusChip, SvgIcon } from '@elementary/common-ui/components';
import { ReactComponent as FailureIcon } from '@elementary/common-ui/assets/close.svg';
import { DomainStatus } from '../types';

const DomainChip = ({ status }: { status: DomainStatus }) => {
  if (status === 'unknown') return null;
  const chipStatus =
    status === 'validated' ? 'verified' : 'pending_verification';
  const icon =
    status === 'validated' ? (
      <VIcon width={14} />
    ) : (
      <SvgIcon width={12} strokeColor="orange" strokeWidth={2}>
        <FailureIcon />
      </SvgIcon>
    );
  const tooltip =
    status == 'validated'
      ? null
      : 'Contact Elementary support team to validate this domain';
  if (tooltip) {
    return (
      <Tooltip title={tooltip}>
        <span>
          <StatusChip status={chipStatus} icon={icon} />
        </span>
      </Tooltip>
    );
  }
  return <StatusChip status={chipStatus} icon={icon} />;
};

export default DomainChip;
